export default function ProductService($http, appSettings) {
  'ngInject';
  const productSRVs = {};
  const packagesendpoint = `${appSettings.IcebergApiPackagesEndpoint}/packages`;
  const datapointendpoint = appSettings.IcebergApiDatapointsEndpoint;
  const productendpoint = appSettings.InReachApiProductsEndpoint;

  productSRVs.getAllPackages = function () {
    return $http.get(packagesendpoint);
  };

  productSRVs.getPackageById = function (packageid) {
    return $http.get(`${packagesendpoint}/${packageid}`);
  };

  productSRVs.getAllProducts = function () {
    return $http.get(productendpoint);
  };

  productSRVs.getAllProductsNames = function () {
    return new Promise((resolve, reject) => {
      productSRVs.getAllProducts().then((response) => {
        let names = {};
        response.data.forEach((template) => {
          names[template.name.toLowerCase()] = template;
        });
        resolve(names);
      }, reject);
    });
  };

  productSRVs.getProductById = function (productId) {
    return $http.get(`${productendpoint}/${productId}`);
  };

  productSRVs.getTriggersBySchemaId = function (schemaId) {
    return $http.get(`${productendpoint}/${schemaId}/triggers`);
  };

  productSRVs.getFriendlyDatapoint = function () {
    return $http.get(datapointendpoint);
  };

  productSRVs.postNewProduct = function (product) {
    return $http.post(productendpoint, product);
  };

  productSRVs.deleteProduct = function (productId) {
    return $http.delete(`${productendpoint}/${productId}`);
  };

  productSRVs.addEquipment = function (productId, equipmentId) {
    return $http.put(`${productendpoint}/${productId}/equipment/${equipmentId}`);
  };

  productSRVs.updateProduct = function (product) {
    return $http.put(`${productendpoint}/${product.id}`, product);
  };

  return productSRVs;
}
